<template>
  <div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <table-controls-vue
      :has-sticky="true"
      v-if="!loading && sourceItems.length">
      <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
        <thead class="has-cells-vcentered">
          <tr class="is-size-6">
            <th
              class="is-paddingless has-text-centered"
              style="z-index:2;">
              <columns-toggles
                :entries="columnsList"
                :source="columns"
                @update="updateColumns"></columns-toggles>
            </th>
            <th>
              <sortable
                @sort="$emit('sort', 'last_name', $event)"
                sort-id="last_name"
                :sort="sourceSortBy.last_name"
                label="Nom"></sortable>
            </th>
            <th>
              <span>Prénom</span>
            </th>
            <th
              v-if="showColumn('role')">
              <sortable
                @sort="$emit('sort', 'role', $event)"
                sort-id="role"
                :sort="sourceSortBy.role"
                label="Fonction"></sortable>
            </th>
            <th>
              <sortable
                @sort="$emit('sort', 'tiers__name', $event)"
                sort-id="tiers__name"
                :sort="sourceSortBy.tiers__name"
                label="Tiers"></sortable>
            </th>
            <th
              v-if="showColumn('type')">
              <span>Type</span>
            </th>
            <th
              v-if="showColumn('email')">
              <span>Email</span>
            </th>
            <th
              v-if="showColumn('phone')"
              class="is-narrow">
              <span>Téléphone</span>
            </th>
            <th
              v-if="showColumn('usage_count')"
              class="is-narrow">
              <sortable
                @sort="$emit('sort', 'usage_count', $event)"
                sort-id="usage_count"
                :sort="sourceSortBy.usage_count"
                label="Utilisations"></sortable>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tbody class="has-cells-vcentered">
          <tr
            v-for="(interlocuteur, i) in sourceItems"
            :key="interlocuteur.pk"
            class="is-size-6"
            :id="'e' + interlocuteur.pk">
            <td class="has-text-centered is-cell-hoverable">
              <avatar
                :item="interlocuteur"
                :i="i"
                class="is-medium"></avatar>
            </td>
            <td class="is-cell-hoverable">
              <router-link
                :to="{name: 'TiersInterlocuteurs', params: {id: interlocuteur.tiers.pk}}"
                class="fullLink">
                <span class="is-uppercase">{{ interlocuteur.last_name }}</span>
              </router-link>
            </td>
            <td class="is-cell-hoverable">
              <router-link
                :to="{name: 'TiersInterlocuteurs', params: {id: interlocuteur.tiers.pk}}"
                class="fullLink">
                {{ interlocuteur.first_name }}
              </router-link>
            </td>
            <td v-if="showColumn('role')">
              <span v-if="interlocuteur.role">{{ interlocuteur.role }}</span>
              <span v-else>-</span>
            </td>
            <td class="is-cell-hoverable is-narrow is-truncate">
              <router-link
                :to="{name: 'TiersVue', params: {id: interlocuteur.tiers.pk}}"
                :title="interlocuteur.tiers.name">
                {{ interlocuteur.tiers.name }}
              </router-link>
            </td>
            <td v-if="showColumn('type')">
              <span class="tag is-light is-border">{{ tiersTypeLabel(interlocuteur.tiers.type) }}</span>
            </td>
            <td v-if="showColumn('email')">
              <span
                v-if="interlocuteur.email"
                :title="interlocuteur.email">{{ interlocuteur.email | truncate(35) }}</span>
              <span v-else>-</span>
            </td>
            <td
              v-if="showColumn('phone')"
              class="is-nowrap">
              <phone-number
                v-if="interlocuteur.phone"
                :phone="interlocuteur.phone"></phone-number>
              <span v-else>N.C</span>
            </td>
            <td
              v-if="showColumn('usage_count')"
              class="has-text-centered">
              {{ interlocuteur.usage_count || 0 }}
            </td>
            <td class="has-text-centered">
              <display-button-list
                :buttons="buttonList"
                :data="interlocuteur">
              </display-button-list>
            </td>
          </tr>
        </tbody>
      </table>
    </table-controls-vue>
    <div v-show="!loading && !sourceItems.length">
      <div class="is-padding">
        <h2 class="title is-3 has-text-weight-bold">
          Aucun interlocuteur disponible
        </h2>
        <a
          class="has-text-primary"
          @click="$emit('reset')"
          v-if="hasFilter"><span class="icon"><i
            class="fas fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnConf, Error } from '@/mixins'
import { TIERS_RESOURCE, tiersTypeLabel } from './tiersConstants'

export default {
  name: 'InterlocuteursList',
  mixins: [ColumnConf, Error],
  props: {
    sourceItems: {
      type: Array,
      default: () => []
    },
    sourceSortBy: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasFilter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columnsConfResource: 'tiers-interlocuteurs',
      buttonList: [
        {
          action: (id, interlocuteur) => {
            this.$router.push({ name: 'TiersInterlocuteurs', params: { id: interlocuteur.tiers.pk } })
          },
          icon: 'fa-address-card',
          text: 'Fiche tiers'
        },
        {
          action: (id, interlocuteur) => {
            this.$router.push({
              name: 'TiersEdit',
              params: { id: interlocuteur.tiers.pk },
              query: { interlocuteur: interlocuteur.pk }
            })
          },
          icon: 'fa-user-edit',
          text: 'Modifier fiche'
        },
        {
          action: (id, interlocuteur) => {
            this.deleteInterlocuteur(interlocuteur)
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer interlocuteur'
        }
      ]
    }
  },
  computed: {
    columnsShow () {
      return {
        role: { label: 'Fonction', mobile: true },
        type: { label: 'Type', mobile: false },
        email: { label: 'Email', mobile: true },
        phone: { label: 'Téléphone', mobile: false },
        usage_count: { label: 'Utilisations', mobile: false }
      }
    }
  },
  methods: {
    tiersTypeLabel,
    /**
     * Supprime l'interlocuteur de sa fiche tiers (impossible si c'est le dernier)
     * @param {object} interlocuteur - ligne à plat avec son tiers parent
     */
    async deleteInterlocuteur (interlocuteur) {
      let value = await this.$swal({
        title: 'Suppression interlocuteur',
        text: `Êtes vous sûr de vouloir supprimer ${interlocuteur.last_name || ''} ${interlocuteur.first_name || ''} de la fiche « ${interlocuteur.tiers.name} » ?`,
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      try {
        let { data: tiers } = await this.$api.getOne(TIERS_RESOURCE, interlocuteur.tiers.pk)
        const interlocuteurs = (tiers.interlocuteurs || []).filter(i => i.pk !== interlocuteur.pk)
        await this.$api.patch(TIERS_RESOURCE, tiers.pk, { interlocuteurs })
        this.$toasted.global.success('Interlocuteur supprimé')
        this.$emit('reload')
      } catch (e) {
        if (e.response && JSON.stringify(e.response.data).includes('INTERLOCUTEUR_IN_USE')) {
          this.$toasted.global.danger('Suppression impossible : cet interlocuteur est utilisé — voir l\'onglet Historique de la fiche')
        } else if (e.response && e.response.status === 400) {
          this.$toasted.global.danger(e.response.data.message || e.response.data.exception)
        } else {
          this.$toasted.global.danger('Erreur lors de la suppression !')
        }
      }
    }
  }
}
</script>
